// extracted by mini-css-extract-plugin
var _1 = "CommentHistoryView-module__animatedBackground--Zy34b";
var _2 = "CommentHistoryView-module__content--CCca9";
var _3 = "CommentHistoryView-module__editor--K4uLR";
var _4 = "CommentHistoryView-module__editorWrapper--Q5Sj0";
export { _1 as "animatedBackground", _2 as "content", _3 as "editor", _4 as "editorWrapper" }
